module.exports = __webpack_public_path__ + "img/ph_qrcode_xiaohongshu.426304d.webp";